/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import { Drawer, message, Popconfirm, Select } from "antd";
import { map, isEmpty, uniqBy, filter, sortBy, orderBy, cloneDeep } from 'lodash';
import { StopOutlined, CloseOutlined, CloseCircleOutlined } from '@ant-design/icons';
import moment from "moment-timezone";
import * as yup from 'yup';
import Loader from "../../../../Common/Component/Loader";
import EmailRemainder from "../Common/EmailRemainder";
import PrivateNotes from "../Common/PrivateNotes";
import UpdateContact from "../Common/UpdateContact";
import AddAuthorizedUsers from "../Common/AddAuthorizedUsers";
import visa from '../../../../../Assets/images/visa_dark.svg'
import american from '../../../../../Assets/images/american_express_dark.svg'
import AddAddress from "../Common/AddAddress";
import UpdateBlockList from "../Common/UpdateBlockList";
import EmptyData from "../../../../Common/Component/EmptyData";
import {convertFirstCharToUppercase} from "../../../../../Tools/convertFirstLetterToUppercase";
import { aboutUsData } from "../../../../../Assets/data/aboutUsList";

const {Option} = Select;
const notificationTypes = [
  'technician_assigned',
  'technician_enroute',
  'technician_checkin',
  'service_complete',
  'service_issues',
  'billing_notifications'
];
class AccountDetails extends Component {
  fattJs = null;

  constructor(props) {
    super(props);
    this.state = {
      customer: {},
      serviceOrder: {},
      loader: false,
      notifications: {},
      billing: {
        charge: false,
        printInvoice: false,
        emailInvoice: false
      },
      emailReminderModal: false,
      updateContact: false,
      addAuthorizedUser: false,
      showCreditCard: false,
      can_edit: false,
      blockList: {},
      cardList: {},
      cardDetail: {},
      notificationList: {},
      authorizedUser: {},
      pricingHistory: {},
      is_btn_active: false, // add/update credit card
      card_holder_name: '',
      card_address: {},
      showAddAddressView: false,
      addresses: [],
      updateBlockList: false,
      errors: {},
      deleteCardUuid: '',
      card_number : '',
      card_expiry_month : '',
      card_expiry_year : '',
      card_cvv : '',
      stax_customer_id : '',
      hideAddNewButton: false,
      charge_invoices_to_card: true,
      default_card: ''
    }
  }

  componentDidMount = () => {
    const {
      getCustomerDetail,
      getBlockList,
      getCardList,
      customerId,
      fieldOffice,
      getAuthorizedUserList,
      getPricingHistory,
    } = this.props;

    this.props.onClearFromOverview();

    if (customerId) {
      this.setState({loader: true});
      getCustomerDetail(customerId) // get customer detail
      getBlockList({user__uuid: customerId}) // get block list
      getCardList({user__uuid: customerId}) // get card list
      // getNotification({user__uuid: customerId}) // get notification list
      getAuthorizedUserList({user__uuid: customerId}) // get authorized user list
      getPricingHistory({service_order__user__uuid: customerId}) // get pricing history
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {
      authorizedUser,
      cardList,
      cardDetail,
      customer,
      serviceOrder,
      blockList,
      pricingHistory,
      deleteCardUuid
    } = this.state;
    this.setState({ loader: false });

    // get customer info
    if (Object.keys(nextProps?.customerList?.customer).length > 0
      && JSON.stringify(nextProps?.customerList?.customer) !== JSON.stringify(customer)) {
      this.setState({ 
        customer: nextProps?.customerList?.customer,
        stax_customer_id : nextProps?.customerList?.customer?.stax_customer,
        stax_public_apikey: nextProps?.customerList?.customer?.field_office?.stax_public_apikey,
        hideAddNewButton: nextProps?.customerList?.customer?.field_office?.stax_public_apikey ? false : true
      });
    }

    // Update cards list
    if(Object.keys(nextProps?.AddStaxInfo?.data)?.length > 0 && 
      nextProps?.AddStaxInfo?.data !== this.props?.AddStaxInfo?.data)
    {
      this.updateCardList();
    }

    // get service order
    if (Object.keys(nextProps?.serviceOrder?.data).length > 0
      && JSON.stringify(nextProps?.serviceOrder?.data) !== JSON.stringify(serviceOrder)) {
      this.setState({ serviceOrder: nextProps?.serviceOrder?.data });
    }

    // get notification list
    if (Object.keys(nextProps?.notificationList?.data).length > 0
      && JSON.stringify(nextProps?.notificationList?.data) !== JSON.stringify(this.props.notificationList.data)) {
      this.setState({ notificationList: nextProps?.notificationList?.data?.results });
    }

    // update notifications
    if (Object.keys(nextProps?.updateNotification?.data).length > 0
      && JSON.stringify(nextProps?.updateNotification?.data) !== JSON.stringify(this.props.notificationList.data)) {
      this.setState({ notificationList: nextProps?.updateNotification?.data });
    }

    // update card detail
    if (Object.keys(nextProps?.updateCardDetail?.data).length > 0 && JSON.stringify(nextProps?.updateCardDetail?.data) !== JSON.stringify(this.props.updateCardDetail?.data)) {
      this.setState({ updateCard: nextProps?.updateCardDetail?.data, loader: true });
      this.props.getCardList({user__uuid: this.props.customerId}) // get card list
      // message.success('Updated Successfully');
    }

    // delete card detail
    if (Object.keys(nextProps?.deleteCardDetail?.data).length > 0 && JSON.stringify(nextProps?.deleteCardDetail?.data?.uuid) === JSON.stringify(deleteCardUuid)) {
      this.setState({ loader: true, deleteCardUuid: '' });
      this.props.getCardList({user__uuid: this.props.customerId}) // get card list
      // message.success('Updated Successfully');
    }

    // get block list
    if (Object.keys(nextProps?.blockList?.data).length > 0
      && JSON.stringify(nextProps?.blockList?.data) !== JSON.stringify(blockList)) {
      this.setState({ blockList: nextProps?.blockList?.data });
    }

    // get card list
    if (Object.keys(nextProps?.cardList?.data).length > 0 && JSON.stringify(nextProps?.cardList?.data) !== JSON.stringify(cardList)) {
      let default_cards = nextProps?.cardList?.data?.results?.filter((item) => item.charge_invoice_card === true);

      if(nextProps?.cardList?.data?.results?.length > 0 && default_cards.length > 0)
      {
        this.setState({
          loader: false ,
          cardList: nextProps?.cardList?.data, 
          default_card: default_cards[0].uuid
        });
      }

      else
      {
        this.setState({ cardList: nextProps?.cardList?.data, loader: false });
      }
    }

    // get authorized user list
    if (Object.keys(nextProps?.authorizedUser?.userList).length > 0 && JSON.stringify(nextProps?.authorizedUser?.userList) !== JSON.stringify(authorizedUser)) {
      this.setState({ authorizedUser: nextProps?.authorizedUser?.userList, loader: false });
    }

    // get pricing history
    if (Object.keys(nextProps?.pricingHistory?.data).length > 0
      && JSON.stringify(nextProps?.pricingHistory?.data) !== JSON.stringify(pricingHistory)) {
      this.setState({ pricingHistory: nextProps?.pricingHistory?.data });
    }

    // send email for cc expiry
    if (Object.keys(nextProps?.emailReminder?.sendEmail).length > 0) {
      const idx = cardList?.results?.findIndex(obj => obj.uuid === cardDetail.uuid);
      if (idx > -1) {
        Object.assign(cardList?.results?.[idx], {email_reminder: [...cardList?.results?.[idx]?.email_reminder, nextProps?.emailReminder?.sendEmail]});
        this.setState({cardList})
      }
    }

    // get list of technician
    if (Object.keys(nextProps?.fieldTechnician?.technicianList).length > 0
      && JSON.stringify(nextProps?.fieldTechnician?.technicianList) !== JSON.stringify(this.state.tech_list)) {
      this.setState({ tech_list: nextProps?.fieldTechnician?.technicianList });
    }

    if (this.state.hideAddNewButton) {
      message.error('Error occur while loading stax. please contact to admin.', 500);
    }
  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_corporate = logged_in_user_role?.includes('accounting_corporate')
    const is_service_rep = logged_in_user_role?.includes('service_rep')
    const is_corporate = logged_in_user_role?.includes('admin')
    return {hide_delete_card: (is_franchise_owner || is_account_corporate || is_service_rep || is_corporate)}
  }

  // on update contact details
  onUpdateClick = () => {
    const {updateCustomer} = this.props;
    const {customer} = this.state;
    let isPrimaryExist = false;

    filter(customer?.phone_numbers, (obj) => {
      if (obj.primary) {
        isPrimaryExist = true
      }
    })

    if (!isPrimaryExist) {
      customer.phone_numbers[0].primary = true
    }

    updateCustomer(customer?.uuid, {phone_numbers: customer?.phone_numbers, emailaddress_set: customer.emailaddress_set});
  };

  // on billing value change
  onBillingOptionsChanged = (e, item) => {
    const { cardList } = this.state;
    const idx = cardList?.results?.findIndex(obj => obj.uuid === item.uuid);
    const value = e.target.checked;
    Object.assign(cardList.results[idx], { [e.target.name]: value })
    this.setState({ cardList }, () => {
      const {cardList} = this.state;
      const idx = cardList?.results?.findIndex(obj => obj.uuid === item.uuid);
      let res = cardList?.results;
      if (!res?.[idx]?.address?.geo_location) delete res?.[idx]?.address?.geo_location;
      this.props.updateCard({
        'user_uuid': this.props.customerId,
        'uuid': res?.[idx]?.uuid,
        'address': res?.[idx]?.address,
        // 'stripe_card_details': res?.[idx]?.stripe_card_details,
        'card_holder_name': res?.[idx]?.card_holder_name,
        'email_invoice': res?.[idx]?.email_invoice || false,
        'charge_invoice_card': res?.[idx]?.charge_invoice_card || false,
        // 'print_invoice_card': res?.[idx]?.print_invoice_card || false,
      })
    });
  };

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  //toggle email remainder modal
  toggleEmailRemainder = (value) => {
    this.setState({ emailReminderModal: value });
  };

  //toggle update contact
  toggleUpdateContact = (value) => {
    this.setState({ updateContact: value });
  };

  //toggle add authorized user
  toggleAddAuthorizedUser = (value) => {
    this.setState({ addAuthorizedUser: value });
  };

  //toggle credit card drawer
  toggleCreditCard = (value, can_edit = false) => {
    this.props.getCardList({ user__uuid: this.props.customerId }) // get card list
    this.setState({ showCreditCard: value, can_edit });
    const FattJs = window.FattJs;
    const { stax_public_apikey } = this.state;
    if (stax_public_apikey) {
      const fattJs = new FattJs(stax_public_apikey, {
        number: {
          id: "card-number",
          placeholder: "Card Number",
          style:
            "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-number div
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style:
            "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-cvv div
        }
      });
      fattJs.showCardForm().then(handler => {
        console.log('form loaded',handler);
      }).catch(err => {
        console.log('error init form ' + err);
      });
      this.fattJs = fattJs;
    } else {
      message.error('Error occur while loading stax. please contact to admin.', 10);
    }
  };

  // toggle Update Block List
  toggleUpdateBlockList = (value) => {
    this.setState({ updateBlockList: value });
  }

  // on notification change
  onNotificationChange = (e, type) => {
    const { notificationList } = this.state;
    const idx = notificationList.findIndex(obj => obj.type === type);
    if (idx > -1) {
      notificationList[idx] = Object.assign(notificationList[idx], { [e.target.name]: e.target.checked });
      this.setState({ notificationList });
    }
  }

  // on update notification
  onUpdateNotification = () => {
    const { notificationList } = this.state;
    const { updateNotificationById } = this.props;
    this.setState({loader: true});
    updateNotificationById && updateNotificationById(notificationList);
    setTimeout(() => this.setState({loader: false}), 1000);
  }

  // on primary phone number changed
  onPhonePrimaryChanged = (item) => {
    const {customer} = this.state;
    map(customer?.phone_numbers, (obj) => obj.primary = false)
    const index = customer.phone_numbers.findIndex(obj => obj.phone === item.phone)
    customer.phone_numbers[index].primary = true
    this.setState({customer}, () => this.onUpdateClick())
  }

  // on primary SMS phone number changed
  onSMSPrimaryChanged = (item) => {
    const {customer} = this.state;
    map(customer?.phone_numbers, (obj) => obj.can_send_sms = false)
    const index = customer.phone_numbers.findIndex(obj => obj.phone === item.phone)
    customer.phone_numbers[index].can_send_sms = true
    this.setState({customer}, () => this.onUpdateClick())
  }

  // on primary email changed
  onEmailPrimaryChanged = (item) => {
    const {customer} = this.state;
    map(customer?.emailaddress_set, (obj) => obj.primary = false)
    const index = customer.emailaddress_set.findIndex(obj => obj.email === item.email)
    customer.emailaddress_set[index].primary = true
    this.setState({customer},() => this.onUpdateClick())
  }
  
  // on Clear
  onClear = () => {
    this.setState({
      card_address: {
        address: '',
        city: '',
        state: '',
        zip_code: ''
      },
      card_holder_name: '',
      addresses: [],
      showAddAddressView: false,
      errors: {}
    });
  };

  //on cancel
  onCancel = () => {
    this.toggleCreditCard(false);
    this.onClear();
  }

  // card validation
  validation = () => {
    const { card_holder_name, card_address, card_number, card_expiry_month, card_expiry_year, card_cvv } = this.state;
    setTimeout(() => {
      const cardSchema = yup.object().shape({
        card_number : this.fattJs.validNumber ? null : yup.string().nullable().required('Card Number is required'),
        card_expiry_month : yup.string().nullable().required('Card expire month is required'),
        card_expiry_year : yup.string().nullable().required('Card expire year is required').min(4, 'Card expire year is invalid.').max(4, 'Card expire year is invalid.'),
        card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('Card CVC is required'),
        card_address: yup.object().shape({
          address: yup.string().required("Address is required"),
          state: yup.string().required("State is required"),
          city: yup.string().required("City is required"),
          zip_code: yup.string().required("Zipcode is required")
        }),
        card_holder_name: yup.string().required("Cardholder name is required"),
      })

      const cardData = { card_address, card_holder_name, card_number, card_expiry_month, card_expiry_year, card_cvv };
      cardSchema.validate(cardData, { abortEarly: false }).then(() => {
        this.setState({errors: {}, is_btn_active: true})
        this.addNewCard()
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {
          message.error(item.message,10);
          err_data[item.path] = item.message
        })
        console.error("Error : ",err_data);
        this.setState({errors: err_data, is_btn_active: false});
        message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
      });
    }, 500);
  }

  // Add New Card
  addNewCard = () => {
    const {
      card_address,
      card_holder_name,
      customer,
      card_number,
      card_expiry_month,
      card_expiry_year,
      charge_invoices_to_card
    } = this.state;
    const {customerId} = this.props;
    this.setState({loader : true});

    const token_obj = {
      address_1: card_address ? card_address.address : null,
      address_city: card_address ? card_address.city : null,
      address_state: card_address ? card_address.state : null,
      address_zip: card_address ? card_address.zip_code : null,
      month : card_expiry_month ? card_expiry_month : null,
      year : card_expiry_year ? card_expiry_year : null,
      card_number: card_number ? card_number : null,
      email: customer && customer.email ? customer.email : null,
      firstname: customer && customer.first_name ? customer.first_name : null,
      lastname: customer && customer.last_name ? customer.last_name : null,
      method: 'card',
      person_name: customer ? `${customer.first_name} ${customer.last_name}` : null,
      phone: this.state.card_phone
    }
    if (this.state.stax_customer_id) {
      token_obj['customer_id'] = this.state.stax_customer_id;
    }

    this.fattJs.tokenize(token_obj).then((res) => {
      if(this.state.stax_customer_id === null || this.state.stax_customer_id === '') {
        this.setState({
          stax_customer_id : res.customer_id
        });
      }
      delete card_address.uuid;
      Promise.all([
        this.props.addNewCard({
          'user_uuid': customerId,
          'address': card_address,
          'stax_card_token' : res.id,
          'card_holder_name': card_holder_name,
          'charge_invoice_card': charge_invoices_to_card,
        })
      ]).then(() => {
        this.onCancel();
      });      
    }).catch((err) => {
      this.setState({ loader : false });
      message.error(err.message,10);
      console.error("Error : ",err);
    })
  }

  // update validation
  updateValidate = () => {
    const { card_holder_name, card_address } = this.state;
    setTimeout(() => {
      const cardSchema = yup.object().shape({
        card_holder_name: yup.string().required("Cardholder name is required"),
        card_address: yup.object().shape({
          address: yup.string().required("Address is required"),
          state: yup.string().required("State is required"),
          city: yup.string().required("City is required"),
          zip_code: yup.string().required("Zipcode is required")
        })
      });
      const cardData = { card_address, card_holder_name };
      cardSchema.validate(cardData, { abortEarly: false }).then(() => {
        this.setState({errors: {}, is_btn_active: true})
        this.onUpdateCard()
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {
          message.error(item.message,10);
          err_data[item.path] = item.message
        })
        console.error("Error : ",err_data);
        this.setState({errors: err_data, is_btn_active: false});
        message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
      });
    }, 500);
  }

  // toggle add address view
  toggleAddAddress = (value) => {
    this.setState({showAddAddressView: value})
  }

  // on add address
  onAddAddress = (obj) => {
    const {addresses} = this.state;
    addresses.push({billing_address: {uuid: (Math.random() * 10).toString(), ...obj}});
    this.setState({addresses});
  }

  // Update card
  onUpdateCard = () => {
    const {customerId} = this.props;
    const { card_holder_name, card_address, cardDetail, charge_invoices_to_card } = this.state;
    this.setState({ loader: true })
    if (card_address.uuid.includes('.')) delete card_address.uuid;
    if (!card_address.geo_location) delete card_address.geo_location;
    this.props.updateCard({
      'user_uuid': customerId,
      'uuid': cardDetail?.uuid,
      'address': card_address,
      'card_holder_name': card_holder_name,
      'charge_invoice_card': charge_invoices_to_card
    });
    //To get updated list for service order for addresses
    this.props.getServiceOrder({user__uuid: customerId, limit: 5, offset: 0, is_active: true});
    this.toggleCreditCard(false);
    this.onClear();

  }

  //Set service Address
  serviceAddressCheck = (e, item) => {
    let { card_address } = this.state;
    if (e.target.checked) {
      card_address = cloneDeep({
        "uuid": item.uuid,
        "address": item.address,
        "city": item.city,
        "state": item.state,
        "zip_code": item.zip_code,
      })
      this.setState({
        card_address
      })
    }
  }

  // Update cards list
  updateCardList = () => {
    this.setState({loader: true});
    this.props.getCardList({ user__uuid: this.props.customerId }) // Get card list
  }

  // Render service address
  renderServiceOrder = () => {
    const { serviceOrder, addresses, card_address, cardList,cardDetail } = this.state;

    let updatedCardList =  cardList?.results.filter(( obj ) =>{ 
      if (obj?.address?.formatted_address === card_address.formatted_address && cardDetail?.uuid === obj.uuid){
        return obj;
      }else if(obj?.address?.formatted_address !== card_address.formatted_address && cardDetail?.uuid !== obj.uuid){
        return obj;
      }
    });
    let updatedServiceOrderAddress =  serviceOrder?.results?.filter(( obj ) =>{ 
      if (obj?.billing_address?.formatted_address === card_address.formatted_address && cardDetail?.address?.uuid === obj?.billing_address?.uuid){
        return obj;
      }else if(obj?.billing_address?.formatted_address !== card_address.formatted_address &&  cardDetail?.address?.uuid !== obj?.billing_address?.uuid){
        return obj;
      }
    });

    const list = [...(updatedCardList || []), ...(updatedServiceOrderAddress || []), ...addresses];
    let addressList = [];
    filter(list,(obj) => obj.billing_address ? addressList.push({...obj.billing_address}) : addressList.push({...obj.address}));

    addressList = uniqBy(orderBy([...addressList], 'uuid', 'desc'), 'formatted_address');
    if (addressList && addressList.length > 0) {
      addressList = addressList.filter(x => { return x.uuid !== null });
    }
    return map(addressList, (item, i) => {
      return (
        <div className="fitem-check" key={i}>
          <input
            type="radio" name="address"
            checked={card_address?.uuid === item.uuid}
            id={`address${i}`}
            className="fitem-ck-input"
            onChange={(e) => { this.serviceAddressCheck(e, cloneDeep(item)) }}
          />
          <label htmlFor={`address${i}`} className="fitem-ck-txt">            
            {`${item.address}, ${item.city}, ${item.state}, ${item.zip_code} `}
          </label>
        </div>
      )
    })
  }

  // render primary info
  renderPrimaryInfo = () => {
    const { customer, authorizedUser, tech, tech_list } = this.state;
    const name = customer?.first_name ? `${customer?.first_name} ${customer?.last_name}` : '';
    let authorizedUserName = ''
    if (customer && isEmpty(customer?.emailaddress_set)) {
      customer.emailaddress_set = [{email: customer?.email, primary: true}]
    }
    map(sortBy(authorizedUser?.results, 'created_at'), (item, index) => authorizedUserName += `${index !== 0 ? ', ' : ''}${item?.user_name}`)
    return (
      <div className="card order1">
        <div className="card-title flex">
          <h5>Primary information</h5>
          {/* {customer?.is_active && <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.deActivateCustomerConfirm()}}>Inactive</button>} */}
          {
            customer?.is_active ?
              <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.deActivateCustomerConfirm() }}>Inactive</button> :
              <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.activateCustomer() }}>Activate</button>
          }
        </div>
        <div className="card-body">
          <div className="flex flex-start mb-10">
            <div className="label">
              <b>Primary User:</b>
              <span>Authorized Users: </span>
            </div>
            <div className="value">
              <b>{name}</b>
              <span>{authorizedUserName}</span>
            </div>
          </div>
          <div className="mb-10">
            <b>
              <a href={'/#'} onClick={(e) => { e.preventDefault(); this.toggleAddAuthorizedUser(true) }}><u>Add Authorized User</u></a>
            </b>
          </div>
          <div className="fitem inline-check-list">
            {/* Phone numbers */}
            {
              map(orderBy(customer?.phone_numbers, 'primary', 'desc'), (item, index) => {
                return (
                  <div className="fitem-check" key={`checkboxPhone${index}`}>
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`checkboxPhone${index}`}
                      name={`phone${index}`}
                      checked={item?.primary}
                      onChange={() => this.onPhonePrimaryChanged(item)}
                    />
                    <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt">
                      {`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.primary ? '(Primary)' : ''}`}
                    </label>
                  </div>
                )
              })
            }
            {/* SMS Phone numbers */}
            {
              map(orderBy(customer?.phone_numbers || [], 'can_send_sms', 'desc'), (item, index) => {
                if (item?.can_send_sms) {
                  return (
                    <div className="fitem-check" key={`checkboxSms${index}`}>
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`checkboxSms${index}`}
                        name={`Sms${index}`}
                        checked={item?.can_send_sms}
                        onChange={() => this.onSMSPrimaryChanged(item)}
                      />
                      <label htmlFor={`checkboxSms${index}`} className="fitem-ck-txt">
                        {`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.can_send_sms ? '(Primary SMS)' : ''}`}
                      </label>
                    </div>
                  )
                }
              })
            }
            {/* Emails */}
            {!customer?.is_dummy_email &&
              map(orderBy([...(customer?.emailaddress_set || [])], 'primary', 'desc'), (item, index) =>
              item?.email && !item.email.includes('doody.com') ?
                <div className="fitem-check" key={`firstCheckboxEmail${index}`}>
                  <input
                    type="checkbox"
                    className="fitem-ck-input"
                    id={`firstCheckboxEmail${index}`}
                    name={`firstCheckboxEmail${index}`}
                    checked={item?.primary}
                    onChange={() => this.onEmailPrimaryChanged(item)}
                  />
                  <label htmlFor={`firstCheckboxEmail${index}`} className="fitem-ck-txt text-lowercase">
                    {`${item?.email} ${item?.primary ? '(Primary)' : ''}`}
                  </label>
                </div> : ''
              )
            }
          </div>
          <a href={'/#'} onClick={(e) => { e.preventDefault(); this.toggleUpdateContact(true) }}><u>Update Contact Details</u></a>
        </div>
      </div>
    )
  };

  // render communication preference
  renderCommunication = () => {
    const { notificationList } = this.state;
    return (
      <div className="card comm-pref order4">
        <div className="card-title flex">
          <h5>Communication Preferences</h5>
          {
            notificationList?.length > 0 && <button
              className="btn btn-warning"
              onClick={() => this.onUpdateNotification()}
            >Update</button>
          }
        </div>

        <div className="card-body">
          {
            notificationList?.length > 0 &&
            <div className="fitem-check text-right">
              <label htmlFor="checkbox" className="fitem-ck-txt text-right"><b>Email</b></label>
              <label htmlFor="checkbox" className="fitem-ck-txt text-right"><b>Text</b></label>
            </div>
          }
          {
            map(notificationList, (item, index) => {
              if (notificationTypes.includes(item.type)) {
                return (
                  <div className={"flex ai-center mb-10"} key={`notification${index}`}>
                    <label><b>{item?.type_display}</b></label>
                    <div className="inline-check-list rcheck flex sm-checks gcheck">
                      <div className="fitem-check">
                        <input
                          type="checkbox"
                          className="fitem-ck-input"
                          id={`checkboxNotificationEmail${index}`}
                          name={`email`}
                          checked={item?.email}
                          onChange={(e) => this.onNotificationChange(e, item?.type)}
                        />
                        <label htmlFor={`checkboxNotificationEmail${index}`} className="fitem-ck-txt"/>
                      </div>
                      <div className="fitem-check">
                        <input
                          type="checkbox"
                          className="fitem-ck-input"
                          id={`checkboxText${index}`}
                          name={`text`}
                          checked={item?.text}
                          onChange={(e) => this.onNotificationChange(e, item?.type)}
                        />
                        <label htmlFor={`checkboxText${index}`} className="fitem-ck-txt"/>
                      </div>
                    </div>
                  </div>
                )
              }
            })
          }
        </div>
      </div>
    )
  };

  // render Billing Preference
  renderBilling = () => {
    const { cardList, default_card } = this.state;
    const {hide_delete_card} = this.getLoggedInUserRole()
    return (
      <div className="card order2">
        <div className="card-title flex">
          <h5>Billing Preferences</h5>
          <div>
            { cardList?.results?.length < 3 ? <button
              className="btn btn-warning"
              onClick={() => {
                this.setState({ cardDetail: {} })
                this.toggleCreditCard(true)
              }}
            >Add New</button> : <span />}
          </div>
        </div>
        <div className="card-body">
          {cardList?.results?.length > 0 ?
            map(orderBy(cardList?.results, 'uuid', 'asc'), (item, index) => {
              const expDate = `${JSON.parse(item.stax_payment_object).card_exp.toString().slice(0,2)}/${JSON.parse(item.stax_payment_object).card_exp.toString().slice(2,6)}`;
              const diff = moment(expDate).diff(moment(), 'days');
              const displayDiff = moment(expDate).fromNow();
              const displayText = diff < 0 ? `expired for ${displayDiff}` : `is due to expire ${displayDiff}`;
              const renderDefault = (default_card === '' && index === 0) || default_card === item.uuid;

              return (
                <React.Fragment key={`card${index}`}>
                  {hide_delete_card ? <div className={'flex flex-end mb-10'}>
                    <Popconfirm
                      title="Are you sure?"
                      onConfirm={() => {
                        this.setState({loader: true, deleteCardUuid: item?.uuid})
                        this.props.deleteCard({uuid: item?.uuid})
                      }}
                      okText="Yes"
                      cancelText="No"
                      overlayClassName={"popup-width"}
                    >
                      <CloseCircleOutlined className={'danger'}/>
                    </Popconfirm>
                  </div> : ''}
                  <div className="flex ai-center mb-10" key={`card${item?.uuid}`}>
                    <div className="card_img flex ai-center">
                      {JSON.parse(item.stax_payment_object).card_type === 'visa' ?
                        <img height="25" src={visa} alt="" /> :
                        <img height="25" src={american} alt="" />} &nbsp;&nbsp;
                      <label className="m-0">{!isEmpty(JSON.parse(item.stax_payment_object)) ? `${JSON.parse(item.stax_payment_object).card_type} ending in ${JSON.parse(item.stax_payment_object).card_last_four}` : ''}</label>
                    </div>

                    <button
                      className="btn btn-warning xs-btn"
                      onClick={() => {
                        this.setState({
                          cardDetail: item,
                          card_address: item?.address,
                          card_holder_name: item?.card_holder_name,
                          charge_invoices_to_card: item?.charge_invoice_card,
                        }, () => this.toggleCreditCard(true, true))
                      }}
                    >Update</button>
                  </div>
                  {renderDefault &&
                    <label className="m-0">Default Payment Method</label>
                  }
                  {renderDefault &&
                    <hr />
                  }
                  {
                    (diff <= 60) &&
                      <blockquote className="horiz">
                        <b>{`This customer’s credit card ${displayText}.`}</b>
                        <button className="btn btn-warning mt-10" onClick={() => {this.setState({cardDetail: item}); this.toggleEmailRemainder(true)}}>Send Reminder Email</button>
                      </blockquote>
                  }                    
                </React.Fragment>
              )
            })
            : <EmptyData />
          }
        </div>
      </div>
    )
  }

  // render pricing history
  renderPricingHistory = () => {
    const { pricingHistory } = this.state;
    return (
      <div className="card order5">
        <div className="card-title">
          <h5>Pricing History</h5>
        </div>
        <div className="card-body">
          {pricingHistory?.results?.length > 0 ?
            map(pricingHistory?.results, (item, index) =>
              <div className="notes" key={`pricingHistory${index}`}>
                <span>{`Price Rise, activated ${moment(item?.preferred_start_date).format('MMM do YYYY')} May 1st 2019\n\nIncrease from $${item?.service_order?.calculated_price?.total_price_per_service} per service to $${item?.service_order?.calculated_price?.total_price_per_service}`}</span>
                <small>{`Accepted by client, ${item?.accepted_by?.first_name} ${item?.accepted_by?.last_name} ${moment(item?.preferred_start_date).format('MMM do YYYY')}\n\nProcessed manually by ${item?.processed_by?.first_name} ${item?.processed_by?.last_name}.`}</small>
              </div>
            ) : <EmptyData />
          }
        </div>
      </div>
    )
  };

  // render hear about us
  renderHearAbout = () => {
    const { customer } = this.state;
    const { hearAboutUs } = this.props;
    const temp = aboutUsData.filter(item => hearAboutUs?.includes(item.value)).map(item2 => {return item2.name}).join(', ')
    const formatted_outreach = customer?.outreach ? convertFirstCharToUppercase(customer?.outreach.replace("_", " ")) : '-';
    const formatted_attribution = customer?.channel_attribution && customer?.channel_attribution?.name !== "Unknown" ? convertFirstCharToUppercase(customer?.channel_attribution.name) : '-';

    return (
      <div className="card">
        <div className="card-title">
          <h5>Source & Attribution</h5>
        </div>
        <div className="card-body">
          <span>
            Outreach: <b style={{marginLeft: "5px"}}>{formatted_outreach}</b>
          </span><br/>
          <span>
            {`How did you hear about us: `} <b>{!isEmpty(hearAboutUs) ? `${temp}` : '-'}</b>
          </span><br/>
          <span>
            Attribution: <b style={{marginLeft: "5px", maxWidth: "none"}}>{formatted_attribution}</b>
          </span>
        </div>
      </div>
    )
  };

  // render block list
  renderBlockList = () => {
    const { blockList } = this.state;
    return (
      <div className="card">
        <div className="card-title flex">
          <h5>Block List</h5>
          <button className="btn btn-warning" onClick={() => this.toggleUpdateBlockList(true)}>Update</button>
        </div>
        <div className="card-body">
          {blockList?.results?.length > 0 ?
            map(blockList?.results, (item, index) =>
              <div className="blockedueser  flex flex-start mb-10" key={`block${index}`}>
                <div className="bico">
                  <StopOutlined />
                </div>
                <div className="btext">
                  <b className="d-block">{`${item?.blocked_user_details?.first_name} ${item?.blocked_user_details?.last_name}`}</b>
                  <span>{`Reason: ${item?.reason}`}</span>
                </div>
              </div>
            ) : <EmptyData />
          }
        </div>
      </div>
    )
  };

  // render drawer
  renderCreditCardDrawer = () => {
    const { card_holder_name, showCreditCard, can_edit, showAddAddressView, errors, charge_invoices_to_card } = this.state;
    const closeDrawer = () => {this.toggleCreditCard(false); this.onClear()}
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={closeDrawer}
        visible={showCreditCard}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="rdrawer filter_drawer_wrapper">
          <div className="card-head flex ai-center">
            <h4>{can_edit ? 'Update Credit Card' : 'Add Credit Card'}</h4>
            <CloseOutlined onClick={closeDrawer}/>
          </div>
          
          <div className="card-row flex-column">
          
            <div className="card-full">
              <div className="form-group">
                {
                  !can_edit ?
                    <>
                      <div className="fitem">
                        <label>Card Number</label>
                        <div id="card-number" className="form--control"></div>
                      </div>
                      <div className="fitem">
                        <label>CVV</label>
                        <div id="card-cvv" className="form--control"></div>
                      </div>
                    </>
                    : ''
                }
                <div className="fitem">
                  <label>Cardholder Name</label>     
                  <input
                    type="text"
                    value={card_holder_name || ''}
                    onChange={(e) => {
                      this.setState({
                        card_holder_name: e.target.value
                      });
                    }} className="form--control" placeholder="Cardholder Name" disabled={can_edit} />
                  {errors?.['card_holder_name'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_holder_name']}</label> : ''}
                </div>
            
                {!can_edit ?
                  <React.Fragment>
                    <div className="fitem half-fitem">
                      <div className="fitem half-fitem">
                        <label>Expiration Month</label>
                        <input type="text" className="form--control" placeholder="MM" maxLength={2} 
                          inputMode="numeric"
                          onPaste={(event) => {
                            if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyPress={(e) => {
                            const pattern = /[0-9]/;
                            const inputChar = String.fromCharCode(e.charCode);
                            if (!pattern.test(inputChar)
                            ) {
                              // invalid character, prevent input
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => { this.setState({ card_expiry_month: e.target.value }) }} />
                        {errors?.['card_expiry_month'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_month']}</label> : ''}
                      </div>
                      <div className="fitem half-fitem">
                        <label>Expiration Year</label>
                        <input type="text" className="form--control" placeholder="YYYY" maxLength={4} 
                          inputMode="numeric"
                          onPaste={(event) => {
                            if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyPress={(e) => {
                            const pattern = /[0-9]/;
                            const inputChar = String.fromCharCode(e.charCode);
                            if (!pattern.test(inputChar)
                            ) {
                              // invalid character, prevent input
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => { this.setState({ card_expiry_year: e.target.value }) }} />
                        {errors?.['card_expiry_year'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_year']}</label> : ''}
                      </div>
                    </div>
                  </React.Fragment> : ''
                }

                <div className="fitem half-fitem" style={{marginTop: "20px"}}>
                  <div className="fitem half-fitem" style={{display: "flex", alignItems: "center"}}>
                    <span style={{color: "#6f6f6f", fontWeight: "bold"}}>Charge invoices to card</span>
                  </div>
                  <div className="fitem half-fitem" style={{display: "flex", justifyContent: "flex-end"}}>
                    <div className="can-toggle can-toggle--size-small">
                      <input
                        id="charge_invoices_to_card"
                        type="checkbox"
                        className="fitem-ck-input"
                        name={"charge_invoices_to_card"}
                        checked={!charge_invoices_to_card} 
                        onChange={(e) => {this.setState({charge_invoices_to_card: !e.target.checked})}} 
                      />
                      <label htmlFor="charge_invoices_to_card" className="fitem-ck-txt black">
                        <div 
                          className="can-toggle__switch"
                          data-unchecked="Yes"
                          data-checked="No"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr/>            
            <div className="card-full pt-0">
              <div className="">
                <div className="mr-2 flex">
                  <b>Billing Address</b>
                  <a href="/#" className="action_link primary" onClick={(e) => { e.preventDefault(); this.toggleAddAddress(true)}}><b>Add New Address</b></a>
                </div>
                <div className="inline-check-list mt-10">
                  {this.renderServiceOrder()}
                  {(errors['card_address.address'] || errors['card_address.city'] || errors['card_address.state'] || errors['card_address.zip_code']) ?
                    <label className="new_err_msg"><i className="las la-info-circle"/>{'Billing address is required'}</label> : ''}
                  {showAddAddressView &&
                  <AddAddress
                    onCancel={this.toggleAddAddress}
                    onAdd={this.onAddAddress}
                  />}
                </div>
                
              </div>              
            </div>
          </div>
          <div className="footer">
            <button className={`btn btn-bdr`} onClick={() => this.onCancel()}>Cancel</button>
            {can_edit ? <button
              className={`btn`}
              onClick={() => this.updateValidate()}>
              {'Update Card'}
            </button> : <button
              className={`btn`}
              onClick={() => this.validation()}>
              {'Add Card'}
            </button> }
          </div>
        </div>
      </Drawer>
    )
  };

  // render private notes
  renderPrivateNotes = () => {
    return <PrivateNotes
      customerId={this.props.customerId}
      getAccountNotes={this.props.getAccountNotes}
      addAccountNotes={this.props.addAccountNotes}
      accountNotes={this.props.accountNotes}
    />
  }

  render() {
    const {
      loader,
      emailReminderModal,
      customer,
      updateContact,
      addAuthorizedUser,
      cardDetail,
      showCreditCard,
      updateBlockList
    } = this.state;
    const { customerId } = this.props;

    return (
      <React.Fragment>
        <script src="https://fattjs.fattpay.com/js/fattmerchant.js"></script>
        <div className="block-row">
          <div className="card-row show-lg">
            {loader && <Loader />}
            <div className="card-col">
              {this.renderPrimaryInfo()}
              {this.renderHearAbout()}
              {this.renderBlockList()}
            </div>
            <div className="card-col">
              {this.renderBilling()}
              {this.renderPricingHistory()}
              {this.renderPrivateNotes()}
            </div>
          </div>
          <div className="card-row hide-lg">
            {loader && <Loader />}
            <div className="card-col">
              {this.renderPrimaryInfo()}
              {this.renderBlockList()}
            </div>
            <div className="card-col">
              {this.renderBilling()}
              {this.renderPricingHistory()}
              {this.renderHearAbout()}
            </div>
            <div className="card-col">
              {this.renderPrivateNotes()}
            </div>
          </div>
          {emailReminderModal && <EmailRemainder
            visible={emailReminderModal}
            customer={customer}
            cardDetail={cardDetail}
            emailReminder={this.props.emailReminder}
            handleOk={(obj) => this.props.sendEmailReminder(obj)}
            handleCancel={() => this.toggleEmailRemainder(false)}
          />}
          {updateContact && <UpdateContact
            openDrawer={updateContact}
            customerList={this.props.customerList}
            getCustomerDetail={this.props.getCustomerDetail}
            customerId={this.props.customerId}
            closeDrawer={() => this.toggleUpdateContact(false)}
            onUpdate={this.props.updateCustomer}
            notificationList={this.props.notificationList} // api
            updateNotificationById={this.props.updateNotificationById} // api
            getNotification={this.props.getNotification} // api
            GoogleApi={this.props.GoogleApi}
            getGeocodeAddress={this.props.getGeocodeAddress} // api
            resetGeocodeAddress={this.props.resetGeocodeAddress} // api
          />}
          {addAuthorizedUser && <AddAuthorizedUsers
            openDrawer={addAuthorizedUser}
            customer={customer}
            customerId={customerId}
            updateCustomer={this.props.updateCustomer}
            authorizedUser={this.props.authorizedUser}
            getAuthorizedUserList={this.props.getAuthorizedUserList}
            addAuthorizedUser={this.props.addAuthorizedUser}
            deleteAuthorizedUser={this.props.deleteAuthorizedUser}
            closeDrawer={() => this.toggleAddAuthorizedUser(false)}
          />}
          {updateBlockList && <UpdateBlockList
            openDrawer={updateBlockList}
            closeDrawer={() => this.toggleUpdateBlockList(false)}
            customerId={this.props.customerId}
            //APIs
            getBlockList={this.props.getBlockList}
            getUserList={this.props.getUserList}
            addBlockUser={this.props.addBlockUser}
            deleteBlockUser={this.props.deleteBlockUser}

            // reducers
            blockList={this.props.blockList}
            userList={this.props.userList}
          />}
          {showCreditCard && this.renderCreditCardDrawer()}
        </div>
      </React.Fragment>
    );
  }
}

export default AccountDetails;
